import 'requestidlecallback-polyfill';
import 'intersection-observer';
import polyfillIntl from './intl';
import polyfillFindLast from './findLast';

export default async function polyfill(locale: string) {
    await polyfillIntl(locale);
    polyfillFindLast();
}
